module.exports = __webpack_public_path__ + "static/media/cover3.4875e7ae.jpeg";